import classNames from "classnames"
import Link from "./link"
import { StyledGhost } from "./ghostLink.styles"

export const GhostLink = ({ wrapperClass, className, component, ...linkProps}) => {
  const Component = component || Link
  return (
    <StyledGhost className={classNames('ghost-wrapper', wrapperClass)}>
      <Component className={classNames(className, 'prime')} {...linkProps} />
      <Component className={classNames(className, 'ghost')} sx={{}} {...linkProps} />
    </StyledGhost>
  )
}

